import React, { useCallback, useRef, useState } from "react";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem, } from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { getAllGoldInwardData } from "../services/gold-product-inward.service";
import { Card } from "react-bootstrap";
import { HttpStatus, UpdateInwardDataIds } from "modules/core";
import { updateGoldAndDiamondInwardRecords } from "utils/inward";
import notistack from "modules/core/notistack";
import useMenuData from "Layout/LayoutMenuData";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const GoldProductInward = () => {
    const { loadStats } = useMenuData()
    let setSelectedRows: Array<number> = [];
    const dataGridRef = useRef<DataGrid>(null);

    const dataSource = new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            try {
                const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                parameterList.append("MaterialType", 'gold');
                parameterList.append("IsSNMCC", 'false');
                parameterList.append("IsReceived", 'false');
                const response = await getAllGoldInwardData(parameterList);
                // return {
                //     data: response?.data || [],
                //     totalCount: response?.data.length || 0,
                // };
                return response
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        }
    });

    const handleSelectionChange = (e: any) => {
        setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
    };

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const updateDiamondAndGoldInword = async () => {
        try {
            await loadStats();
            if (setSelectedRows.length > 0) {
                const model = new UpdateInwardDataIds();
                model.productHeaderIdList = setSelectedRows;
                const response = await updateGoldAndDiamondInwardRecords(model);
                if (response.status === 200) {
                    dataGridRef.current?.instance.clearSelection();
                    dataGridRef.current?.instance.refresh();
                    notistack.notifyFromApi(response);
                } else {
                    notistack.notifyFromApi(response);
                }
            } else {
                notistack.warning("Please Select Product");
            }
        } catch (error) {
            console.error("Failed to fetch inward Data:", error);
        } finally {
            await loadStats();
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Gold Inward </h5>
                            {HasPermission('ProductHeader.Write') && <button onClick={updateDiamondAndGoldInword} className="submit-btn">
                                Receive
                            </button>}
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission('ProductHeader.Read') &&
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    ref={dataGridRef}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                    onSelectionChanged={handleSelectionChange}
                                    onCellPrepared={(e) => {
                                        if (['data', 'header'].includes(e.rowType)) {
                                            e.cellElement.style.textAlign = 'center';
                                        }
                                    }}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Selection mode="multiple" />
                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Pager

                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />

                                    <Column
                                        caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        cellRender={renderSerialNumber}
                                    />
                                    <Column allowFiltering={true} dataField="storeCode" caption="Store Code" dataType="string" />
                                    <Column allowFiltering={true} dataField="invoiceNo" caption="Invoice Number" dataType="string" />
                                    <Column allowFiltering={false} dataField="invoiceDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" />
                                    {/* <Column allowFiltering={false} dataField="inwardDate" caption="Inward Date" dataType="date" format="dd-MM-yyyy"  /> */}
                                    <Column allowFiltering={true} dataField="huid" caption="HUID" dataType="string" />
                                    <Column allowFiltering={true} dataField="styleNo" caption="Style Number" dataType="string" />
                                    <Column allowFiltering={false} dataField="metalColor" caption="Metal Color" dataType="string" />
                                    <Column allowFiltering={false} dataField="metalKT" caption="Metal KT" dataType="string" />
                                    <Column allowFiltering={false} dataField="grossWt" format="#,##0.000" caption="Gross Weight" dataType="string" />
                                    <Column allowFiltering={false} dataField="qty" caption="Quantity" dataType="string" />
                                    <Column allowFiltering={false} dataField="netWt" format="#,##0.000" caption="Gold Weight" dataType="string" />
                                    <Column allowFiltering={true} dataField="bagNo" caption="BagNo." dataType="string" />
                                    <Column allowFiltering={false}
                                        dataField="isSRP"
                                        caption="Is SRP" dataType="boolean"

                                        cellRender={({ data }) => (
                                            <span>{data?.isSRP ? "Yes" : "No"}</span>
                                        )} />
                                </DataGrid>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default GoldProductInward;